export default __webpack_public_path__ + "static/media/Hobbies.cadf0ba2.jpg";